@if (cautionCode) {
  <mat-list-item>
    <mat-icon fontIcon="fa-user" fontSet="far" style="align-content: end" matListItemAvatar></mat-icon>
    @if (hiddenFromOperative) {
      <mat-icon fontIcon="fa-eye-slash" fontSet="far" style="align-content: end" matListItemAvatar [matTooltip]="'Shown to operative as:\n' + cautionCode.Ptac_AlternateText"   matTooltipClass="multiline-tooltip">
        </mat-icon>
    }
    <div matListItemTitle><span>{{ cautionCode.Ptac_Description }}</span></div>
    <div matListItemLine><i>Tenant Caution Code: {{ cautionCode.Ptac_TenantAttributeCodeID }}</i></div>

  </mat-list-item>
}
